import styled from "styled-components";

export interface PersonComponentTheme
{
    palette:
    {
        tertiary: string;
        darkBorder: string;
        neutralPrimary: string;
    };
}

export interface PersonComponentProps
{
    theme?: PersonComponentTheme;
}

export const PersonComponent = styled.div<PersonComponentProps>`
    box-sizing: border-box;
    border-radius: 32px;
    min-width: 200px;
    height: 48px;
    margin-top: 8px !important;
    padding-right: 8px;
    cursor: default;
    border: ${(props) => props.theme ? `1px solid ${props.theme.palette.tertiary}` : '1px solid transparent'};
    > *
    {
        display: inline-flex;
        vertical-align: middle;
        margin: 7px 0 7px 7px;
        @media(width: 640px)
        {
            width: 83%
        }
        @media(min-width: 641px) and (max-width: 800px)
        {
            width: 87%;
        }
        @media(min-width: 1025px) and (max-width: 4000px)
        {
            width: 87%;
        }
    }
    button
    {
        position: relative;
        z-index: 2000;
        box-sizing: border-box;
        line-height: 26px;
        height: 32px;
        min-width: unset !important;
        min-height: unset !important;
        width: 10%;
        margin-left: 0 !important;
        border-radius: 16px;
        border: ${(props) => props.theme ? `1px solid ${props.theme.palette.tertiary} !important` : '1px solid transparent !important'};
        cursor: pointer;
        padding: 0 7.5px;

        i.ironia-icon:after
        {
            font-size: 17px;
        }
    }
    .ms-Persona
    {
        cursor: default;
        @media (min-width: 1366px) and (max-width: 1919.99px)
        {
            width: 87%;
        }
        .ms-Persona-coin
        {
            .ms-Persona-imageArea
            {
                .ms-Persona-initials
                {
                    background: #D9E6FA;
                    span
                    {
                        color: ${(props) => props.theme ? props.theme.palette.darkBorder : 'inherit'};
                    }
                }
            }
        }
        .ms-Persona-details
        {
            min-width: 102px;
            cursor: default;
            @media only screen and (min-width: 641px) and (max-width: 800px)
            {
                min-width: 210px;
            }
            @media only screen and (min-width: 801px) and (max-width: 1023.99px)
            {
                min-width: 50%;
            }
            .ms-Persona-primaryText
            {
                @media only screen and (min-width: 641px) and (max-width: 800px)
                {
                    max-width: 210px;
                }
                @media only screen and (width: 768px)
                {
                    max-width: 260px;
                }
                @media only screen and (min-width: 800px) and (max-width: 1024px)
                {
                    max-width: 290px;
                }
                @media only screen and (min-width: 1366px) and (max-width: 1919.99px)
                {
                    max-width: 100%;
                }
                .ms-TooltipHost
                {
                    color: ${(props) => props.theme ? `${props.theme.palette.neutralPrimary} !important` : 'inherit'};
                }
            }
            .ms-Persona-secondaryText
            {
                max-width: 16em;
                .ms-TooltipHost
                {
                    color: ${(props) => props.theme ? `${props.theme.palette.darkBorder} !important` : 'inherit'};
                }
            }
        }
    }
    .ms-layer 
    {
        display: none;
    }
`;